import DragAndDropUploader from './DragAndDropUploader';

export default DragAndDropUploader;
